import type { FaireProductEntity } from "../../entity_types/product";

export const p_7x6hvuzygf: FaireProductEntity = {
  token: "p_7x6hvuzygf",
  type: "product",
  name: "Mens Cotton Grey Buffalo Poppy Socks",
  brandToken: "b_9ha1ebi2",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/e549dcb90e2db512df6d15b8551701f7f2aa05c7e22354361bb149f0b6564fe3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5d846859ee8cdb6bf60b7c4292f31aa15bc0d20ba4e8c9ce961b18aac9f20bf8.jpeg",
    "https://cdn.faire.com/fastly/161c7851faa6a69b8e59bd5a49d4cd3085e0f479ac552908ba0e23d09773085e.jpeg",
  ],
  priceDollars: 9.7,
  description:
    "\nFor that Golden State of mind… Serving up our super soft, original design, allover buffalo poppies print. Inspired by the California state flower and the Buffalo Paddock Bison of Golden Gate Park in San Francisco. Rep the yin and yang of the West with this tough buffalo and silken blossom t-shirt. Classic California.\n\nAnimal print pattern is an original, hand drawn design by artist Jamai Lowell. \n\nSize Fits Mens 7-12 range\n\nFabric (100% cotton)\nWash care instructions (machine wash cold, tumble dry low, do not bleach, do not iron)\nDesigned in the USA",
  tags: [],
  msrpDollars: 19.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:51.732Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
